/* ==========================================================================
   LIMETRE - JS customizado
   Unica funcao hoje: na home, deixar o banner passar por baixo do header e
   alternar o header entre transparente (sobre o banner) e solido (branco)
   assim que a rolagem passa do banner.
   ========================================================================== */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('limetre-home')) return;

  var section, wrapper, main, banner;

  function cacheElements() {
    section = document.querySelector('.section-header');
    wrapper = document.querySelector('.header-wrapper');
    main = document.getElementById('MainContent');
    banner = main ? main.firstElementChild : null;
    return !!(section && wrapper && main && banner);
  }

  /* Sobe o conteudo ate o topo visual do header, para o banner passar por
     baixo dele. A medicao e feita com o header temporariamente sem sticky,
     senao a posicao dele muda conforme a rolagem. */
  function layout() {
    var prevPosition = section.style.position;

    section.style.setProperty('position', 'static', 'important');
    main.style.removeProperty('margin-top');

    var base = parseFloat(window.getComputedStyle(main).marginTop) || 0;
    var delta = main.getBoundingClientRect().top - wrapper.getBoundingClientRect().top;

    main.style.setProperty('margin-top', base - delta + 'px', 'important');

    if (prevPosition) {
      section.style.setProperty('position', prevPosition);
    } else {
      section.style.removeProperty('position');
    }
  }

  function update() {
    var headerBottom = wrapper.getBoundingClientRect().bottom;
    var bannerBottom = banner.getBoundingClientRect().bottom;
    root.classList.toggle('limetre-header-solid', bannerBottom <= headerBottom);
  }

  function refresh() {
    layout();
    update();
  }

  function init() {
    if (!cacheElements()) return;
    refresh();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
